<template>
  <!-- 超时异常订单管理 -->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
  
    <div class="list-content-div">
      <div class="list-header-title-div">占位订单管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属运营商</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" v-model="queryInfo.isHostOperate" size="small" clearable>
                <el-option label="自运营" value="02"></el-option>
                <el-option label="代运营" value="01"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电网点</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.stationName" placeholder="请输入内容"
                        clearable @keyup.enter.native="getListData(pagination, true)"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">异常类型</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.processingStatus" clearable>
                <el-option label="正常" value="01"></el-option>
                <el-option label="异常" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">桩编号</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.pileCode" placeholder="请输入内容" clearable
                        @keyup.enter.native="getListData(pagination, true)"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">手机号</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.custPhone" placeholder="请输入内容" clearable
                        @keyup.enter.native="getListData(pagination, true)"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                  class="full-width"
                  v-model="searchChargeTime"
                  :picker-options="pickerOptions"
                  style="width:340px;"
                  type="datetimerange"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleChargeDateChange"
              ></el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button class="common-bg-button" @click="getListData(pagination, false)">搜 索</button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
          <div class="">
            <button class="common-bg-button" @click="toExportList" style="width:80px;margin-top:15px">导出</button>
          </div>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
                  :tableConfig="pageConfig.tableConfig"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
    
    <!-- 处理、详情 -->
    <el-dialog title="占位订单处理" :visible.sync="dialogVisible" width="64%" top="8vh" @close="resetForm">
      
      <div class="edit-form" v-if="isEdit">
        
        <!-- 基础信息 -->
        <div class="order-info">
          <div class="order-info-item">
            <div class="item-label">订单编号：</div>
            <div class="item-value">{{ popupFormData.orderNo }}</div>
          </div>
          <div class="order-info-item">
            <div class="item-label">最终SOC：</div>
            <div class="item-value">{{ popupFormData.soc ? popupFormData.soc : 0 }} %</div>
          </div>
          <div class="order-info-item">
            <div class="item-label">订单状态：</div>
            <div class="item-value">{{ popupFormData.chargeStepName }}</div>
          </div>
          <div class="order-info-item">
            <div class="item-label">占位费：</div>
            <div class="item-value">{{ popupFormData.occupyFee ? popupFormData.occupyFee : 0 }} 元</div>
          </div>
          <div class="order-info-item item-with">
            <div class="item-label">充电情况：</div>
            <div class="item-value">{{ popupFormData.chargeProcess }}</div>
          </div>
        </div>
        
        <!-- 数据填写 -->
        <el-form :model="popupFormData" :rules="pageConfig.rules" ref="ruleForm" label-width="110px">
          <el-form-item label="处理结果：" prop="resource" size="small" style="width: 100%">
            <el-radio-group v-model="popupFormData.processingStatus" @input="handleInput">
              <el-radio label="01">正常</el-radio>
              <el-radio label="02">异常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="popupFormData.processingStatus === '02'" label="占位费处理：" prop="region">
            <el-select v-model="popupFormData.occupyHandle" size="small" placeholder="请选择占位费处理方式"
                       style="width: 100%" @change="handleSelectOccupy">
              <el-option label="不收取" value="01"></el-option>
              <el-option label="退款" value="02"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="popupFormData.processingStatus === '02'" label="金 额：">
            <el-input v-model="popupFormData.occupyHandleFee" size="small" style="width: 50%;"></el-input>
            <span style="color: #999;margin-left: 16px;">(最多223.23元)</span>
          </el-form-item>
          <el-form-item label="备注信息" style="width: 100%">
            <el-input type="textarea" v-model="popupFormData.handlerRemark"  size="small"></el-input>
          </el-form-item>
          <el-form-item style="width: 100%;">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
          </el-form-item>
        </el-form>
        
      </div>
      
      <!-- 基础信息 -->
      <div class="order-info" v-else>
        <div class="order-info-item">
          <div class="item-label">订单编号：</div>
          <div class="item-value">{{ popupFormData.orderNo }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">充电电站：</div>
          <div class="item-value">{{ popupFormData.statioName }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">充电方式：</div>
          <div class="item-value">{{ popupFormData.chargeTypeName }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">开始时间：</div>
          <div class="item-value">{{ popupFormData.beginTime }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">结束时间：</div>
          <div class="item-value">{{ popupFormData.endTime }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">充电时长：</div>
          <div class="item-value">{{ popupFormData.chargeLong }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">充电金额：</div>
          <div class="item-value">{{ popupFormData.totalFee ? popupFormData.totalFee : 0 }} 元</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">占位时长：</div>
          <div class="item-value">{{ popupFormData.occupyLong }}</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">占位金额：</div>
          <div class="item-value">{{ popupFormData.occupyFee ? popupFormData.occupyFee : 0 }} 元</div>
        </div>
        <div class="order-info-item">
          <div class="item-label">车主手机：</div>
          <div class="item-value">{{ popupFormData.custPhone }}</div>
        </div>
      </div>
  
      <!-- 操作记录、 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.popListColumns" :operates="pageConfig.operates" :tableData="popupFormData.historys"
                  :tableConfig="pageConfig.popTableConfig" v-if="isEdit"></ZD-table>
        
        <ZD-table :tableColumns="pageConfig.popDetailListColumns" :operates="pageConfig.operates" :tableData="popupFormData.details"
                  :tableConfig="pageConfig.popTableConfig" v-else></ZD-table>
      </div>
      
      <div class="order-detail" v-if="isEdit == false">
        <div>说明：占位费不满半分钟不计费，满半分钟不满一分钟按一分钟计算</div>
        <div>本次电费+服务费 ：{{ popupFormData.actPayFee ? popupFormData.actPayFee : 0 }}元</div>
        <div>占位费：{{ popupFormData.occupyFee ? popupFormData.occupyFee : 0 }}元</div>
        <div>合计金额：{{ popupFormData.totalFee?popupFormData.totalFee:0 }}元（{{ popupFormData.actPayFee ? popupFormData.actPayFee : 0 }}元 + {{ popupFormData.occupyFee ? popupFormData.occupyFee : 0 }}元）</div>
      </div>
      
    </el-dialog>
    
  </div>
</template>

<script>
  import pageConfig from "./page-config";
  export default {
      data(){
          return{
              pageConfig: pageConfig, // 页面配置
              pagination: pageConfig.pagination,
              pickerOptions: {
                  disabledDate(time) {
                      return time.getTime() > Date.now();
                  },
              },
              queryInfo: {
                  occupyStatus: 'Y',
                  pileType: '02',
                  pageNum: 0,
                  pageSize: 10,
              },
              searchChargeTime: [],
              tableData: [],
              
              // 弹窗
              dialogVisible: false,
              isEdit: true,
              popupFormData: {
                  processingStatus: '01',
                  processingStatusName: '正常'
              },
              // 列操作按钮
              operates: {
                  width: 200,
                  fixed: "right",
                  list: [
                      {
                          id: "deal",
                          label: "处 理",
                          type: "primary",
                          show: true,
                          disabled: false,
                          method: (index, row) => {
                              this.toDetail(row, 1);
                          },
                      },
                      {
                          id: "look",
                          label: "查 看",
                          type: "primary",
                          show: true,
                          disabled: false,
                          method: (index, row) => {
                              this.toDetail(row, 2);
                          },
                      },
                  ],
              },
          }
      },
      mounted() {
          this.getListData(this.pagination, true);
      },
      methods: {
          // 数据初始化
          getListData(pagination, reload = false){
              let _ = this;
              _.$U.showLoading(_);
              _.queryInfo.pageNum = pagination.current - 1;
              if (reload) {
                  pagination.current = 1;
                  _.queryInfo.pageNum = 0;
              }
              _.queryInfo.pageSize = pagination.pageSize;
              // 表格数据
              _.$H.post(_, _.$A.order.getDtoList, _.queryInfo).then(res  => {
                  _.$U.hideLoading(_);
                  _.tableData = res.data.data || [];
              })
              // 页码数据
              _.$H.post(_, _.$A.order.getDtoPageInfo, _.queryInfo).then((res) => {
                  _.pagination.total = res.data.data.totalElements || 0;
              });
          },
          // 时间选择
          handleChargeDateChange(val){
              let _ = this;
              if(val && val.length !== 0){
                  _.queryInfo.beginTime = val[0];
                  _.queryInfo.endTime = val[1];
              }else {
                  _.queryInfo.beginTime = '';
                  _.queryInfo.endTime = '';
              }
          },
          //表格详情
          toDetail(row, type) {
              let _ = this;
              _.$U.showLoading(_);
              _.$H.post(_, _.$A.order.getseatOrderDetail, { orderNo: row.orderNo }).then(res => {
                  _.$U.hideLoading(_);
                  _.popupFormData = res.data.data || {};
                  if(type == 1) _.isEdit = true;
                  if(type == 2) _.isEdit = false;
                  _.dialogVisible = true;
              })
          },
          // 占位费处理
          handleSelectOccupy(val){
              let _ = this;
              if(val == '01') _.popupFormData.processingStatusName = '正常';
              if(val == '02') _.popupFormData.processingStatusName = '异常';
          },
          // 处理结果
          handleInput(val){
              let _ = this;
              if(val == '01') _.popupFormData.occupyHandleName = '不收取'
              if(val == '02') _.popupFormData.occupyHandleName = '退款'
          },
          // 导出
          toExportList(){
              let _ = this;
              if (_.queryInfo.beginTime == "" || _.queryInfo.endTime == "" || _.queryInfo.beginTime == undefined || _.queryInfo.endTime == undefined) {
                  _.$U.error("请选择充电时间");
                  return;
              } else {
                  var t1 = new Date(Date.parse(_.queryInfo.endTime.replace(/-/g, "/"))) - new Date(Date.parse(_.queryInfo.beginTime.replace(/-/g, "/")));
                  var t2 = Math.floor(t1 / (24 * 3600 * 1000));
                  if (t2 >= "31") {
                      _.$U.error("充电时间范围不能超过31天");
                      return;
                  }
              }
              _.$U.showLoading(_);
              _.$H.post(_, _.$A.order.exportSeatOrder, _.queryInfo).then((res) => {
                  _.$U.saveExcelFile(res.data.data);
                  var downUrl = "http://ocharge.shzhida.com:6775" + res.data.data.data;
                  window.open(downUrl, "_blank");
                  _.$U.hideLoading(_);
              });
          },
          // 重置
          reset(){
              let _ = this;
              _.searchChargeTime = [];
              _.queryInfo = {
                  occupyStatus: 'Y',
                  pileType: '02',
                  pageNum: 0,
                  pageSize: 10,
                  processingStatus: '',
                  stationName:'',
                  isHostOperate:'',
                  custPhone:'',
                  pileCode:''
              };
              _.getListData(_.pagination, true);
          },
          
          // 处理提交
          submitForm(formName){
              let _ = this;
              _.$refs[formName].validate((valid) => {
                  if (valid) {
                      let params = {
                          orderNo: _.popupFormData.orderNo,
                          processingStatus: _.popupFormData.processingStatus,
                          processingStatusName: _.popupFormData.processingStatusName,
                          occupyHandle: _.popupFormData.occupyHandle,
                          occupyHandleName: _.popupFormData.occupyHandleName,
                          handlerRemark: _.popupFormData.handlerRemark,
                          occupyHandleFee: _.popupFormData.occupyHandleFee
                      }
                      _.$H.post(_, _.$A.order.dealWithSeatOrder, params).then(res => {
                          _.dialogVisible = false;
                          _.getListData(_.pagination, true)
                      })
                  }
              });
          },
          // 取消
          resetForm(formName){
              let _ = this;
              if(formName){
                _.$refs[formName].resetFields();
              }
              _.dialogVisible = false;
          },
      },
  }
</script>

<style lang="less" scoped>
  
  /deep/ .el-dialog__body{
    padding: 8px 24px 24px 24px;
    box-sizing: border-box;
  }
  
  /deep/ .el-form{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }
  
  /deep/ .el-form-item{
    width: 50%;
  }
  
  
  .order-info{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 16px;
    
    .order-info-item{
      width: 50%;
      display: flex;
      align-items: center;
      
      .item-label{
        width: 110px;
        text-align: right;
        font-size: 14px;
        color: #606266;
        line-height: 48px;
        margin-right: 12px;
      }
      
      .item-value{
        color: #333;
        font-size: 14px;
      }
      
    }
  
    .item-with{
      width: 100% !important;
    }
    
  }
  
  
  .order-detail{
    margin-top: 24px;
    
    div{
      font-size: 14px;
      color: #333;
      line-height: 40px;
    }
  }

</style>
